import Request from "@/utils/request";

// 代理查询
export function apiSearchAgent (presentId) {
  return Request({
    url: `/api/v2/app/agent/bind/host?presentId=${presentId}`,
    method: "get"
  });
}

// 移除主播
export function apiDeleteAgent (presentId) {
  return Request({
    url: `/api/v2/app/agent/bind/host/${presentId}`,
    method: "delete"
  });
}

// 获取用户需要进入的 代理中心页面
export function agentPageTypeApi () {
  return Request({
    url: `/api/v2/app/agent/homepage/before`,
    method: "get"
  });

  // todo-mock
  // return Promise.resolve({
  //   status: 200,
  //   data: 1
  // });
}

// 代理中心-新版主页面接口
export function apiFetchInviteV2HomePage () {
  return Request({
    url: `/api/v2/app/agent/homepage/v2`,
    method: "get"
  });

  // todo-mock
  // return Promise.resolve({
  //   "data": {
  //     "agentSumBean": 19000,
  //     "commissionLevelList": [
  //       {
  //         "minBeans": 10000,
  //         "levelRate": 8
  //       }
  //     ],
  //     "currencyAmount": 1000,
  //     "currencyCode": "$",
  //     "inviteCode": "5z3d45",
  //     "inviteCount": 5,
  //     "maxInviteBeanReward": 1200,
  //     "maxShareRate": 30,
  //     "walletBean": 190,
  //     "agentSumBean": 1600,
  //     "weekHostDeductionBeans": 100,
  //     "weekHostEarningBeans": 1500,
  //     "weekAgentCommissionBeans": 1800,
  //     "weekHostDeductionBeans": 200
  //   },
  //   "message": "SUCCESS",
  //   "status": 200
  // });
}

// 代理中心-设置是否访问过
export function agentGuidePageStatusSetApi () {
  return Request({
    url: `/api/v2/app/agent/newerGuide/upload`,
    method: "put"
  });
}

// 代理中心-规则页面
export function rules2PageApi () {
  return Request({
    url: `/api/v2/app/agent/rule/v2`,
    method: "get"
  });
}